<template>
  <div style="padding-left: 10px;padding-right: 10px;min-width: 200px;max-width: 300px;max-height: 250px;overflow: auto">
    <div class="col-xs-12">
      <span>Filter by Countries</span>
    </div>
    <div class="col-xs-12" style="margin-top: 5px">
      <div class="row">
        <div class="col-xs-6">
          <a role="button" class="text-info"
             style="font-size: 12px;font-weight: normal;font-style: italic;" @click="feedFilter"> Select All</a>
        </div>
        <div class="col-xs-6 text-right">
          <a role="button" class="text-info"
             style="font-size: 12px;font-weight: normal;font-style: italic;" @click="clearFilter"> Clear All</a>
        </div>
      </div>
    </div>
    <div class="col-xs-12" style="margin-top: 5px">
      <div v-for="(country, key) in this.sortedCountries" :key="key" style="padding-top: 10px">
        <div class="checkbox checkbox-info checkbox-inline">
          <input :id="uniqId + 'checkbox-country-' + country.name" type="checkbox" v-on:change="countrySelected(country)"
                 v-bind:checked="checked(country)" :disabled="country.nb === 0">
          <label :for="uniqId + 'checkbox-country-' + country.name">
            <template v-if="!country.name">Undefined</template><template v-else>{{country.name}}</template> ({{country.nb}})
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
  .pe-ul > li {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .pe-ul > li > i{
    color: #62cb31;
    font-weight: bold;
  }

  .pe-ul > li > span{
    font-size: 14px;
    font-weight: normal;
  }

</style>
<script>

export default {
  components: {},
  props: ['countries', 'countriesSelected'],
  name: 'CountryBox',
  data () {
    return {
      uniqId: ''
    }
  },
  methods: {
    checked: function (country) {
      if (this.countriesSelected.length !== 0) {
        let tmpCountrySelected = this.countriesSelected.find((countrySelected) => {
          return countrySelected.name === country.name
        })
        if (typeof tmpCountrySelected !== 'undefined') {
          return true
        }
      }
      return false
    },
    countrySelected: function (country) {
      let index = this.countriesSelected.map((e) => {
        return e.name
      }).indexOf(country.name)

      if (index === -1) {
        this.countriesSelected.push(country)
      } else {
        this.countriesSelected.splice(index, 1)
      }
    },
    clearFilter: function (event) {
      this.countriesSelected.splice(0, this.countriesSelected.length)
      event.preventDefault()
    },
    feedFilter: function (event) {
      this.clearFilter(event)

      this.countries.forEach((country) => {
        this.countriesSelected.push(country)
      })
      event.preventDefault()
    }
  },
  beforeMount () {
    this.uniqId = Math.random().toString()
  },
  computed: {
    sortedCountries: function () {
      let undefinedItems = [], sortedItems = []
      if (this.countries.length !== 0) {
        this.countries.forEach((item, key) => {
          if (item.name === '' || typeof item.name === 'undefined' || item.name.toLowerCase() === 'undefined' ||
              item.name.toLowerCase() === 'unknown' || item.name.toLowerCase() === 'incomplete') {
            undefinedItems.push(item)
          } else {
            sortedItems.push(item)
          }
        })
        undefinedItems.sort(function (a, b) { return a.name > b.name })
        return sortedItems.concat(undefinedItems)
      } else {
        return []
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/filter/CountryBox.vue